// import { settings as carbonSettings } from "carbon-components";

const carbonPrefix = 'bx'; // carbonSettings.prefix;

export { carbonPrefix };
